import { render, staticRenderFns } from "./historyData.vue?vue&type=template&id=62ace958&scoped=true&"
import script from "./historyData.vue?vue&type=script&lang=js&"
export * from "./historyData.vue?vue&type=script&lang=js&"
import style0 from "./historyData.vue?vue&type=style&index=0&id=62ace958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ace958",
  null
  
)

export default component.exports